

// const SecondSection = ({ outcomes }) => {
//   const section = outcomes?.[0];
//   if (!section) return null;

//   return (
//     <div
//       style={{
//         padding: "0 24px 24px 24px", // outer wrapper gives space for the rounded section to breathe
//         boxSizing: "border-box",
//         width: "100%",
//         fontFamily: "Inter, sans-serif",
//       }}
//     >
//       <div
//         style={{
//           background:
//             "linear-gradient(108.4deg, #F6E5FA 1.96%, #DBE5FC 48.81%, #9CC1FF 95.66%)",
//           padding: "60px 48px",
//           boxSizing: "border-box",
//           width: "100%",
//           borderRadius: "32px",
//         }}
//       >
//         {/* HEADING */}
//         <h2
//           style={{
//             fontSize: "52px",
//             fontWeight: 700,
//             lineHeight: "60px",
//             letterSpacing: "0.3%",
//             background:
//               "linear-gradient(271.93deg, #06285F 23.62%, #7A0F97 103.25%)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             backgroundClip: "text",
//             margin: "0 0 40px 0",
//             maxWidth: "800px",
//           }}
//         >
//           {section.heading}
//         </h2>

//         {/* GRID */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
//             gap: "20px",
//           }}
//         >
//           {section.sub?.map((item) => (
//             <div
//               key={item.id}
//               style={{
//                 background: "#F3F8FF",
//                 borderRadius: "16px",
//                 padding: "28px 24px",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "flex-start",
//                 gap: "16px",
//                 boxShadow: "1px 1px 15px 0px #8E01864D",
//               }}
//             >
//               {/* ICON */}
//               <div
//                 style={{
//                   width: "80px",
//                   height: "80px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   flexShrink: 0,
//                 }}
//               >
//                 <img
//                   src={item.imgurl}
//                   alt={item.subheading}
//                   style={{
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "contain",
//                   }}
//                 />
//               </div>

//               {/* SUBHEADING */}
//               <p
//                 style={{
//                   fontSize: "24px",
//                   fontWeight: 700,
//                   lineHeight: "1.2",
//                   letterSpacing: "0.02em",
//                   background:
//                     "linear-gradient(90deg, #7A0F97 0%, #020126 100%)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                   backgroundClip: "text",
//                   margin: 0,
//                 }}
//               >
//                 {item.subheading}
//               </p>

//               {/* DESCRIPTION */}
//               <p
//                 style={{
//                   fontSize: "16px",
//                   fontWeight: 500,
//                   lineHeight: "22px",
//                   color: "#09048C",
//                   margin: 0,
//                 }}
//               >
//                 {item.description}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SecondSection;

const SecondSection = ({ outcomes }) => {
  const section = outcomes?.[0];
  if (!section) return null;

  // "How CureBay AI Drives Better Healthcare Outcomes" → last 3 words in green
  const headingWords  = (section.heading || "").split(" ");
  const headingMain   = headingWords.slice(0, -3).join(" ");
  const headingAccent = headingWords.slice(-3).join(" ");

  const styles = `
    .ss-outer {
      box-sizing: border-box;
      width: 100%;
      font-family: Inter, sans-serif;
      background-color: #ffffff;
      background-image: var(--section-bg-gradient);
    }
    .ss-inner {
      padding: 56px max(60px, calc(50% - 660px));
      box-sizing: border-box;
      width: 100%;
    }
    .ss-heading {
      font-size: 40px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: 0.3%;
      color: var(--color-brand-primary);
      margin: 0 0 32px 0;
      max-width: 720px;
    }
    .ss-heading-accent { color: var(--color-brand-green); }
    .ss-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 20px;
    }
    .ss-card {
      background: #ffffff;
      border: 1px solid #DFF1FB;
      border-radius: 16px;
      padding: 16px 24px 28px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      box-shadow: 0px 0px 15px 0px #80DAF1;
    }
    .ss-icon {
      width: 72px;
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      margin-bottom: 20px;
    }
    .ss-icon img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .ss-subheading {
      font-size: 22px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: 0.02em;
      color: var(--color-brand-primary);
      margin: 0;
    }
    .ss-description {
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
      color: var(--color-text-subheading);
      margin: 0;
    }

    /* ── Tablet large (1101–1279px) ── */
    @media (max-width: 1279px) and (min-width: 1101px) {
      .ss-inner { padding: 48px 40px; }
      .ss-heading { font-size: 36px; }
      .ss-grid { gap: 16px; }
      .ss-card { padding: 24px 18px; }
      .ss-subheading { font-size: 20px; }
    }

    /* ── Tablet (768–1100px) ── */
    @media (max-width: 1100px) and (min-width: 768px) {
      .ss-inner { padding: 40px 28px; }
      .ss-heading { font-size: 30px; margin-bottom: 28px; }
      .ss-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
      .ss-card { padding: 22px 18px; gap: 12px; }
      .ss-icon { width: 60px; height: 60px; margin-bottom: 12px; }
      .ss-subheading { font-size: 20px; }
      .ss-description { font-size: 15px; }
    }

    /* ── Mobile (max 767px) ── */
    @media (max-width: 767px) {
      .ss-inner { padding: 32px 14px; }
      .ss-heading { font-size: 26px; margin-bottom: 20px; max-width: 100%; }
      .ss-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
      .ss-card { padding: 18px 14px; gap: 10px; }
      .ss-icon { width: 52px; height: 52px; margin-bottom: 8px; }
      .ss-subheading { font-size: 16px; }
      .ss-description { font-size: 13px; line-height: 18px; }
    }

    /* ── Small mobile (max 480px) ── */
    @media (max-width: 480px) {
      .ss-inner { padding: 24px 10px; }
      .ss-heading { font-size: 22px; margin-bottom: 16px; }
      .ss-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
      .ss-card { padding: 14px 12px; gap: 8px; }
      .ss-icon { width: 44px; height: 44px; margin-bottom: 4px; }
      .ss-subheading { font-size: 14px; }
      .ss-description { font-size: 12px; line-height: 17px; }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="ss-outer">
        <div className="ss-inner">

          <h2 className="ss-heading">
            {headingMain}{headingAccent && " "}
            {headingAccent && <span className="ss-heading-accent">{headingAccent}</span>}
          </h2>

          <div className="ss-grid">
            {section.sub?.slice(0, 4).map((item) => (
              <div key={item.id} className="ss-card">
                <div className="ss-icon">
                  <img src={item.imgurl} alt={item.subheading} />
                </div>
                <p className="ss-subheading">{item.subheading}</p>
                <p className="ss-description">{item.description}</p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </>
  );
};

export default SecondSection;